//@ts-ignore
import { utils } from "@rjsf/core";



export const isSupportedWidget = (widgetName: string, schema: any, widgets: any) => {
    if (widgetName) {
        try {
            const widget = utils.getWidget(schema as any, widgetName, widgets as any);

            return true;
        } catch (error) {
            // console.log(error)
            return false;
        }
    }
    return true;
};